
function Tiga0() {
    return (
        <div className="kosong">
            <img src={require('../image/302.png')} className='img302'/>
        </div>
    )
}
export default Tiga0;